import { History as HistoryIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { FONT_INTER, FONT_MANROPE } from '../styles/stylesTypography';

interface ActivityLogEmptyStateProps {
  subtitle?: string;
}

const ActivityLogEmptyState: React.FC<ActivityLogEmptyStateProps> = ({
  subtitle = 'There are no activity logs for this entity yet.',
}) => (
  <Box sx={{ textAlign: 'center', py: 4 }}>
    <HistoryIcon sx={{ fontSize: 48, color: Palette.default.disabledText, mb: 2 }} />
    <Typography
      gutterBottom
      sx={{
        fontFamily: FONT_MANROPE,
        fontSize: '1rem',
        fontWeight: 600,
        color: Palette.default.text,
      }}
    >
      No Activity Found
    </Typography>
    <Typography
      sx={{ fontFamily: FONT_INTER, fontSize: '0.875rem', color: Palette.tone3.disabledText }}
    >
      {subtitle}
    </Typography>
  </Box>
);

export default ActivityLogEmptyState;
